import ShareholdersTable from './ShareholdersTable';
import  { settingsBuilder } from  './settings';

export default ShareholdersTable;
export {
    settingsBuilder
};
